import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../@prep/shared/material-components.module';

import { LanguageSelectorModule } from 'src/@prep/shared/language-selector/language-selector.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { PostLoginDepartmentDialogModule } from '../../../dialog/post-login-department/post-login-department-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    LanguageSelectorModule,
    PostLoginDepartmentDialogModule
  ],
  declarations: [LoginComponent],
})
export class LoginModule { }
